import { Grid } from '@mui/material';

import { ConfigurationTranslationsField } from './configuration-translations-field';
import { useAppSelector } from '../../../store/use-appstate-selector';

export const ConfigurationDetailForm = () => {
    const availableLocales = useAppSelector(state => state.supportedLocales);

    return (
        <Grid container={true} spacing={2} sx={{ mt: 1 }}>
            {availableLocales.map(availableLocale => {
                return (
                    <Grid key={availableLocale} item={true} xs={12}>
                        <ConfigurationTranslationsField locale={availableLocale} />
                    </Grid>
                );
            })}
        </Grid>
    );
};
